<script setup>
import {ref, watch} from "vue";
import SquareIconButton from "@/components/global-themed/buttons/SquareIconButton.vue";
import ImproveScoreModal from "@/components/seo-score/partials/modals/ImproveScoreModal.vue";

const props = defineProps({
  visibilityScore: {
    type: Number,
    required: true,
  },
});

const showModal = ref(false);

watch(showModal, () => {
  window.mixpanel('SEO Score: View Improve Score', { visibilityScore: props.visibilityScore })
})
</script>

<template>
  <div
    class="tw-bg-primary-100 tw-border tw-border-primary tw-cursor-pointer tw-rounded-xl tw-py-4 tw-px-5 tw-flex tw-justify-between tw-items-center"
    @click="showModal = true"
  >
    <span class="tw-text-base tw-text-neutral-900">
      How can I improve my score?
    </span>

    <SquareIconButton
      size="small"
      variant="primary"
      class="tw-w-9"
    >
      <svg-vue
        class="tw-w-5 tw-flex-shrink-0"
        icon="icons/external-thin"
      />
    </SquareIconButton>
  </div>

  <ImproveScoreModal
    v-if="showModal"
    :visibility-score="visibilityScore"
    @close="showModal = false"
  />
</template>
